import {sortingCriteria} from "../../components/mobile/sub-menu-items/device/DeviceHelper";

export const initialDeviceState = {
    data: [],
    page: 0,
    rowsPerPage: 5,
    count: 0,
    sorting: `${sortingCriteria[0].value},desc`,
    loading: false,
    wrenchLoading: false,
    wrenchLoaded: false
}

export const initialFilterState = {
    imei: {
        label: "IMEI",
        value: "",
        text: ""
    },
    model: {
        label: "Modello",
        value: "",
        text: ""
    },
    modalitaFornitura: {
        label: "Modalità fornitura",
        value: "",
        text: ""
    },
    tags: {
        label: 'Tag',
        value: []
    },
    collaborators: {
        label: 'Collaboratore',
        value: []
    },
    prodotto: {
        label: "Prodotto",
        value: "",
        text: ""
    },
    descrizione: {
        label: "Descrizione",
        value: "",
        text: ""
    },
    contratto: {
        label: "Contratto",
        value: "",
        text: ""
    },
    assistenza: {
        label: "Assistenza",
        value: "",
        text: ""
    },
    interventiInAssistenza: {
        label: "Interventi in assistenza",
        value: "",
        text: ""
    },
    dataConsegna: {
        name: "Data consegna:",
        from: null,
        to: null
    },
    dataTermine: {
        name: "Data termine assistenza:",
        from: null,
    },
    enterpriseMobilityManagement: {
        label: 'Enterprise Mobility Management',
        value: "",
        text: ""
    }
};

export const initialFilterDataState = {
    loading: false,
    error: false,
    tags: [],
    collaborators: [],
    prodotto: [],
    descrizione: [],
    contratto: [],
    assistenza: [],
    modalitaFornitura: [],
    interventiInAssistenza: "",
    enterpriseMobilityManagement: [],
}

export const initialDeviceSelectedRowState = {
    tagsForDeviceList: [],
    firstRenderTags: []
}

export const initialDeviceSuggestionState = {
    menuItems: [],
    loading: false
}

export const initialActiveServiceRequestState = {
    loading: false,
    value: false
}

export const initialCollaboratorsState = {
    loading: false,
    error: false,
    data: []
}

export const initialKaskoDataState = {
    tableData: [
        {
            prodotto: "Smartphone",
            imei: "1234567890",
            descrizione: "Galaxy S21 5G 256 GB",
            tags: {tags: []},
        }
    ],
    maxToAssociate: 0,
    currentAssociated: 0,
    tableLoading: false
}
